import { FC, Fragment } from 'react';
import { Typography } from '@mui/material';
import { AccountBox as AccountBoxIcon, CloudSync as CloudSyncIcon } from '@mui/icons-material';
import moment from 'moment-timezone';

import Column from '../../../../../components/Column';
import OverviewList, { OverviewListItem } from '../../../../../components/List/OverviewList';

import { Campaign, Platform } from '../../../../../types/Campaign';
import DspCampaignIdValue from '../Value/DspCampaignIdValue';
import DspCampaignLink from '../Link/DspCampaignLink';

interface CampaignPlatformOverviewListProps {
    campaign: Campaign;
}

const CampaignPlatformOverviewList: FC<CampaignPlatformOverviewListProps> = ({ campaign }) => {
    const items: OverviewListItem[] = [
        {
            icon: AccountBoxIcon,
            primary: campaign.platform === Platform.AMAZON ? 'Amazon DSP' : 'DV360',
            secondary: (
                <Column gap={0} alignItems="flex-end">
                    {campaign?.dspCampaignId ? (
                        <Fragment>
                            <DspCampaignLink
                                dspEntityId={campaign?.dspEntity?.entityId as string}
                                dspCampaignId={campaign.dspCampaignId as string}
                                platform={campaign.platform}
                                dv360AdvertiserId={campaign.dealer?.dv360Advertiser}
                            />

                            <DspCampaignIdValue
                                value={campaign.dspCampaignId as string}
                                campaignId={campaign.id}
                                platform={campaign.platform}
                            />
                        </Fragment>
                    ) : (
                        ' - '
                    )}
                </Column>
            ),
        },
        {
            icon: CloudSyncIcon,
            primary: 'Last Sync with DSP',
            secondary: (
                <Column gap={0} alignItems="flex-end">
                    {campaign?.dspCampaignSyncedDate ? (
                        <Fragment>
                            <Typography variant="body2" color="text.primary" fontWeight={500}>
                                {moment(campaign?.dspCampaignSyncedDate).format('MMMM D, YYYY')}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {moment(campaign?.dspCampaignSyncedDate).format('hh:mm A')}
                            </Typography>
                        </Fragment>
                    ) : (
                        ' - '
                    )}
                </Column>
            ),
        },
        {
            icon: CloudSyncIcon,
            primary: 'Last Refresh with DSP',
            secondary: (
                <Column gap={0} alignItems="flex-end">
                    {campaign?.dspCampaignRefreshedDate ? (
                        <Fragment>
                            <Typography variant="body2" color="text.primary" fontWeight={500}>
                                {moment(campaign?.dspCampaignRefreshedDate).format('MMMM D, YYYY')}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {moment(campaign?.dspCampaignRefreshedDate).format('hh:mm A')}
                            </Typography>
                        </Fragment>
                    ) : (
                        ' - '
                    )}
                </Column>
            ),
        },
    ];

    return <OverviewList items={items} sx={{ p: 0 }} />;
};

export type { CampaignPlatformOverviewListProps };
export default CampaignPlatformOverviewList;
